<template>
<div class="container-fluid bg-white sticky-top">
    <div class="container">
        <nav class="navbar navbar-expand-lg bg-white navbar-light py-2 py-lg-0">
            <router-link to="/"  class="navbar-brand">
                <img class="img-fluid" src="@/assets/logo.png" alt="Logo">
            </router-link>
            <button type="button" class="navbar-toggler ms-auto me-0" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarCollapse">
                <div class="navbar-nav ms-auto">
                    <router-link to="/" class="nav-item nav-link active">Home</router-link>
                    <router-link to="/gallery" class="nav-item nav-link">Gallery</router-link>
                    <router-link to="/menu" class="nav-item nav-link">Menu</router-link>
                    <router-link to="/contact" class="nav-item nav-link">Contact</router-link>
                </div>
                <div class="border-start ps-4 d-none d-lg-block">
                    <button type="button" class="btn btn-sm p-0">
                        <a href="https://www.instagram.com/bistrobox.ng/" target="_blank" style="color:black"><i class="fab fa-instagram"></i></a>
                    </button>
                </div>
            </div>
        </nav>
    </div>
</div>
</template>